export const allChapitres = [
  {
    chapitreTitle: "Traumatologie",
    sections: [
      "Brulure oculaire",
      "Contusion oculaire",
      "Plaie oculaire",
      "Hyphéma",
      "HIV",
      "Contusion maculaire",
      "Œdème papillaire",
      "Décollement de rétine",
      "Plaie de paupière",
      "Eclatement de globe",
      "ecchymose palpébral",
    ],
  },
  {
    chapitreTitle: "Infectiologie",
    sections: [
      "Endophtalmie",
      "Hypopion",
      "Abcès de cornée",
      "Cellulite orbitaire",
      "Abcès de paupière",
      "Dacryocystite aigue",
    ],
  },
  {
    chapitreTitle: "Médecine",
    sections: [
      "Crise de GFA",
      "Uvéite",
      "H.R.S",
      "OVCR",
      "OACR",
      "DSR",
      "Rétinite à CMV",
    ],
  },
];
